import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.applySortState()
  }

  applySortState() {
    const sortedHeader = this.element.querySelector('[data-sorted="true"]')
    if (sortedHeader) {
      const column = sortedHeader.dataset.sortColumn
      const direction = sortedHeader.dataset.sortedDirection
      
      const asc = sortedHeader.querySelector(".sort-asc-arrow")
      const desc = sortedHeader.querySelector(".sort-desc-arrow")

      if (direction === "asc" && asc) {
        asc.classList.remove("text-black-400")
        asc.classList.add("text-black-1000")
      }

      if (direction === "desc" && desc) {
        desc.classList.remove("text-black-400")
        desc.classList.add("text-black-1000")
      }
    }
  }

  sort(event) {
    const th = event.currentTarget
    const column = th.dataset.sortColumn

    if (this.currentColumn === column) {
      if (this.currentDirection === "asc") {
        this.currentDirection = "desc"
      } else if (this.currentDirection === "desc") {
        this.currentColumn = null
        this.currentDirection = null
      } else {
        this.currentDirection = "asc"
      }
    } else {
      this.currentColumn = column
      this.currentDirection = "asc"
    }

    const headers = this.element.querySelectorAll("[data-sort-column]")
    headers.forEach(header => {
      header.removeAttribute("data-sorted")
      header.removeAttribute("data-sorted-direction")

      const asc = header.querySelector(".sort-asc-arrow")
      const desc = header.querySelector(".sort-desc-arrow")

      if (asc) asc.classList.remove("text-black-1000")
      if (desc) desc.classList.remove("text-black-1000")

      if (asc && !asc.classList.contains("text-black-400")) asc.classList.add("text-black-400")
      if (desc && !desc.classList.contains("text-black-400")) desc.classList.add("text-black-400")
    })

    if (this.currentColumn && this.currentDirection) {
      const activeTh = this.element.querySelector(`[data-sort-column="${this.currentColumn}"]`)
      if (activeTh) {
        activeTh.dataset.sorted = "true"
        activeTh.dataset.sortedDirection = this.currentDirection

        const asc = activeTh.querySelector(".sort-asc-arrow")
        const desc = activeTh.querySelector(".sort-desc-arrow")

        if (this.currentDirection === "asc" && asc) {
          asc.classList.remove("text-black-400")
          asc.classList.add("text-black-1000")
        }

        if (this.currentDirection === "desc" && desc) {
          desc.classList.remove("text-black-400")
          desc.classList.add("text-black-1000")
        }
      }
    }
  }
}
